import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import {execute, setFieldError, steps, setStep, updateFormValue, saveToHistory} from '../IdfNewPlanSignupSlice';
import BtnSubmit from 'app/Components/Shared/Buttons/BtnSubmit';
import TextInput from 'app/Components/Shared/TextInput/TextInput';
import {validateInput} from 'app/Components/Block/IdfSaleBlock/Constans/Validation';
import {INPUT_TYPE} from 'app/Components/Block/IdfSaleBlock/IdfSaleEnums';
import Buttons from 'app/Components/Block/IdfSaleBlock/Constans/Buttons';
import BottomButtons from 'app/Components/Block/IdfSaleBlock/Constans/BottomButtons';
import {
  createReportIdfNewPlanSignupOrderConfirmationPageButtonClicked,
  createReportIdfNewPlanSignupOrderConfirmationPageDisplayed,
  createReportIdfNewPlanSignupOrderConfirmationPageEditButtonClicked
} from 'app/utilities/reports/createReport';

const ConfirmationStep = (props) => {

  useEffect(() => {
    createReportIdfNewPlanSignupOrderConfirmationPageDisplayed(
      props.userData?.loginData.userDetails.firstName + ' ' + props.userData?.loginData.userDetails.lastName,
      props.userData?.loginData.userDetails.contactNumber,
      props.userData?.loginData.userDetails.IDNumber,
      props.idfNewPlanSignup.nextBpKey,
      props.idfNewPlanSignup.selectedPackage?.packageObj?.price?.value
    )
    props.saveToHistory('confirmation');
  }, []);

  const updateFormValue = (e) => {
    const {name, value} = e.target;
    props.updateFormValue({formName: 'confirmationStep', fieldName: name, value: value});
    const {isValid, errorText} = validateFormField(name, value);
    if (isValid) {
      props.setFieldError({formName: 'confirmationStep', fieldName: name, value: ''});
    } else {
      props.setFieldError({formName: 'confirmationStep', fieldName: name, value: errorText});
    }
  };

  const validateFormField = (name, value) => {
    let isValid, errorText;
    switch (name) {
      case 'email':
        isValid = validateInput(value, INPUT_TYPE.EMAIL);
        errorText = !isValid ? 'מייל לא תקין' : '';
        break;
      default:
        break;
    }
    return {isValid, errorText};
  };

  const handleSubmit = () => {
    createReportIdfNewPlanSignupOrderConfirmationPageButtonClicked(
      props.userData?.loginData.userDetails.firstName + ' ' + props.userData?.loginData.userDetails.lastName,
      props.userData?.loginData.userDetails.contactNumber,
      props.userData?.loginData.userDetails.IDNumber,
      props.idfNewPlanSignup.nextBpKey,
      props.idfNewPlanSignup.selectedPackage?.packageObj?.price?.value
    )
    props.execute();
  };

  const handleEdit = () => {
    createReportIdfNewPlanSignupOrderConfirmationPageEditButtonClicked(
      props.userData?.loginData.userDetails.firstName + ' ' + props.userData?.loginData.userDetails.lastName,
      props.userData?.loginData.userDetails.contactNumber,
      props.userData?.loginData.userDetails.IDNumber,
      props.idfNewPlanSignup.nextBpKey,
      props.idfNewPlanSignup.selectedPackage?.packageObj?.price?.value
    )
    props.setStep(steps.SELECTION);
  };

  return (
    <div className={'confirmation-step-container'}>
      <div className={'top-content'}>
        <span className={'main-title'}>סיכום פרטי הזמנה</span>
        <span className={'secondary-title'}>האם כל הפרטים נכונים?</span>
      </div>
      <div className={'main-content'}>
        <div className={'headline-container'}>
          <div className={'headline'}>חיובים חודשיים</div>
        </div>
        <div className={'product'}>
          <div className={'product-title-container'}>
            <span className={'product-title'}>תוכנית סלולר</span>
            <div onClick={handleEdit}>
              <span className={'edit-button'}>עריכה</span>
            </div>
          </div>
          <div className={'product-description-container'}>
            <span
              className={'product-description'}>{props.idfNewPlanSignup.selectedPackage?.packageObj?.benefitTitle?.value}</span>
            <span className={'product-price'}>{props.idfNewPlanSignup.selectedPackage?.packageObj?.price?.value}</span>
          </div>
        </div>
        <div className={'price-container'}>
          <div className={'price-row'}>
            <span className={'price-title'}>סה"כ חיוב חודשי</span>
            <span className={'price'}>{props.idfNewPlanSignup.selectedPackage?.packageObj?.price?.value}</span>
          </div>
        </div>
        <div className={'email-summary-container'}>
          <span className={'email-summary'}>לאיזה דוא״ל לשלוח את סיכום ההזמנה?</span>
          <TextInput
            error={props.idfNewPlanSignup.confirmationStep.errors?.email}
            onChange={(e) => updateFormValue(e)}
            value={props.idfNewPlanSignup.confirmationStep.email}
            name="email"
            type="text"
            placeholder="דואל"
            required="required"
          />
        </div>
      </div>
      <div className={'button-container'}>
        <BottomButtons onClickNavigation={handleSubmit}
                 canContinue={props.idfNewPlanSignup.confirmationStep.errors?.email === '' && props.idfNewPlanSignup.confirmationStep.email !== ''}
                 continueText={'אישור ההזמנה'} />
      </div>
    </div>

  );
};

const mapStateToProps = (state) => {
  return {
    idfNewPlanSignup: state.idfNewPlanSignup,
    userData: state.authentication
  };
};

const mapDispatchToProps = {
  updateFormValue,
  setFieldError,
  execute,
  setStep,
  saveToHistory
};

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmationStep);
